"use strict";
/**
 * Created on 07 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceTerminationUploadedItem_1 = require("../../../price-termination/model/PriceTerminationUploadedItem");
/**
 * <p>Structure used during processing of uploaded file related to {@link SelloutTermination process}. Contains the core (relevant) data
 * from uploaded file by user and some derived data to ease feedback processing towards user.</p>
 *
 * @see {@link SelloutTerminationUpload} for additional info.
 * @author JMe
 */


var SelloutTerminationUploadedItem =
/*#__PURE__*/
function (_PriceTerminationUplo) {
  _inherits(SelloutTerminationUploadedItem, _PriceTerminationUplo);

  function SelloutTerminationUploadedItem() {
    _classCallCheck(this, SelloutTerminationUploadedItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationUploadedItem).apply(this, arguments));
  }

  return SelloutTerminationUploadedItem;
}(PriceTerminationUploadedItem_1.PriceTerminationUploadedItem);

exports.SelloutTerminationUploadedItem = SelloutTerminationUploadedItem;